import { getChildComponents } from '@adobe/aem-react-editable-components';
import { respGridUtil } from '@marriott/mi-ui-library';
import React, { useMemo } from 'react';

// This component renders a single tab panel's content and is heavily memoized
const TabPanelContent = React.memo<{
  page: object;
  isVisible: boolean;
  nodeName: string;
}>(({ page, nodeName }) => {
  const content = useMemo(() => {
    const cqModel = respGridUtil(page);
    const { cqItems: pageCqItems, cqItemsOrder } = cqModel;
    return getChildComponents({ cqItems: pageCqItems, cqItemsOrder });
  }, [page]);

  if (!content?.length) {
    return null;
  }

  return (
    <div id={`${nodeName}-panel`} className={`${nodeName}-panel`} role="tabpanel" aria-labelledby={nodeName}>
      {content.map((childComponent: React.ReactNode) => (
        <React.Fragment key={content[0].key}>{childComponent}</React.Fragment>
      ))}
    </div>
  );
});

export const TabPanel = React.memo<{
  selectedTab: string;
  tabDetails: { nodeName: string; tabName: string }[];
  cqItems: Record<string, object>;
}>(({ cqItems, selectedTab, tabDetails = [] }) => {
  // Pre-process all valid tabs and their content
  const validTabs = useMemo(() => {
    return tabDetails
      .filter(({ nodeName }) => cqItems?.[nodeName])
      .map(({ nodeName }) => ({
        nodeName,
        page: cqItems[nodeName],
      }));
  }, [cqItems, tabDetails]);

  const selected = validTabs.find(v => v.nodeName === selectedTab);
  return selected ? <TabPanelContent {...selected} isVisible /> : null;
});
